/**
 * Oh My Menu
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.3.07
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EstablishmentDto { 
    id?: number;
    userId: number;
    googlePlaceId?: string;
    autoUpdateInfoFromGoogle: boolean;
    name: string;
    slug?: string;
    description?: string;
    currency: EstablishmentDto.CurrencyEnum;
    website?: string;
    phoneNumber?: string;
    email?: string;
    logo?: string;
    image?: string;
    color?: string;
    instagram?: string;
    spotify?: string;
    facebook?: string;
    twitter?: string;
    pinterest?: string;
    tripadvisor?: string;
    enabledLanguages?: Array<EstablishmentDto.EnabledLanguagesEnum>;
    formattedAddress?: string;
    latitude?: number;
    longitude?: number;
    timezone?: string;
    createdAt?: string;
    updatedAt?: string;
}
export namespace EstablishmentDto {
    export type CurrencyEnum = 'EURO' | 'BRITISHPOUND' | 'UNITEDSTATESDOLLAR';
    export const CurrencyEnum = {
        Euro: 'EURO' as CurrencyEnum,
        Britishpound: 'BRITISHPOUND' as CurrencyEnum,
        Unitedstatesdollar: 'UNITEDSTATESDOLLAR' as CurrencyEnum
    };
    export type EnabledLanguagesEnum = 'SPANISH' | 'ENGLISH' | 'CATALAN' | 'GERMAN' | 'FRENCH' | 'ITALIAN' | 'PORTUGUESE';
    export const EnabledLanguagesEnum = {
        Spanish: 'SPANISH' as EnabledLanguagesEnum,
        English: 'ENGLISH' as EnabledLanguagesEnum,
        Catalan: 'CATALAN' as EnabledLanguagesEnum,
        German: 'GERMAN' as EnabledLanguagesEnum,
        French: 'FRENCH' as EnabledLanguagesEnum,
        Italian: 'ITALIAN' as EnabledLanguagesEnum,
        Portuguese: 'PORTUGUESE' as EnabledLanguagesEnum
    };
}


